export function TimeGuardIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.0011 35.8399C19.106 35.8399 18.2033 35.6161 17.4085 35.1917L12.3932 32.522C8.75896 30.5853 6.49048 26.82 6.49048 22.6997V13.7183C6.49048 10.4005 8.97501 7.54559 12.2697 7.09035L14.0984 6.84344L16.6446 5.16909C17.64 4.52095 18.7974 4.16602 19.9856 4.16602C21.1739 4.16602 22.3313 4.51323 23.3189 5.16909L25.8652 6.84344L27.6938 7.09035C30.9885 7.54559 33.4808 10.3928 33.4808 13.726V22.7074C33.4808 26.8277 31.22 30.5931 27.5781 32.5298L22.5627 35.1995C21.768 35.6238 20.873 35.8399 19.9702 35.8399H20.0011Z"
        fill="url(#paint0_linear_2800_12609)"
      />
      <path
        d="M30.286 13.7195V22.7008C30.286 25.6251 28.6734 28.3103 26.0886 29.6837L21.0732 32.3534C20.3942 32.7084 19.5841 32.7084 18.9128 32.3534L13.8974 29.6837C11.3126 28.3103 9.69995 25.6251 9.69995 22.7008V13.7195C9.69995 11.9834 10.9885 10.5096 12.7014 10.2704L14.7385 9.99268C15.078 9.94638 15.402 9.82292 15.6952 9.63774L18.4189 7.84765C19.3757 7.22266 20.6103 7.22266 21.567 7.84765L24.2908 9.63774C24.5763 9.83064 24.9003 9.94638 25.2475 9.99268L27.2845 10.2704C29.0052 10.5096 30.286 11.9757 30.286 13.7195Z"
        fill="url(#paint1_linear_2800_12609)"
      />
      <g opacity="0.62">
        <path
          d="M20.0001 25.5652C18.8769 25.5652 17.9639 24.6521 17.9639 23.5289V22.0434H16.4784C15.3552 22.0434 14.4421 21.1304 14.4421 20.0072C14.4421 18.884 15.3552 17.971 16.4784 17.971H17.9639V16.4855C17.9639 15.3623 18.8769 14.4492 20.0001 14.4492C21.1233 14.4492 22.0363 15.3623 22.0363 16.4855V17.971H23.5218C24.645 17.971 25.5581 18.884 25.5581 20.0072C25.5581 21.1304 24.645 22.0434 23.5218 22.0434H22.0363V23.5289C22.0363 24.6521 21.1233 25.5652 20.0001 25.5652Z"
          fill="url(#paint2_radial_2800_12609)"
        />
        <path
          d="M20.0001 25.5652C18.8769 25.5652 17.9639 24.6521 17.9639 23.5289V22.0434H16.4784C15.3552 22.0434 14.4421 21.1304 14.4421 20.0072C14.4421 18.884 15.3552 17.971 16.4784 17.971H17.9639V16.4855C17.9639 15.3623 18.8769 14.4492 20.0001 14.4492C21.1233 14.4492 22.0363 15.3623 22.0363 16.4855V17.971H23.5218C24.645 17.971 25.5581 18.884 25.5581 20.0072C25.5581 21.1304 24.645 22.0434 23.5218 22.0434H22.0363V23.5289C22.0363 24.6521 21.1233 25.5652 20.0001 25.5652Z"
          fill="url(#paint3_linear_2800_12609)"
        />
      </g>
      <path
        d="M23.5289 18.9997H20.9999V16.4707C20.9999 15.92 20.5507 15.4707 19.9999 15.4707C19.4492 15.4707 18.9999 15.92 18.9999 16.4707V18.9997H16.4709C15.9202 18.9997 15.4709 19.449 15.4709 19.9997C15.4709 20.5504 15.9202 20.9997 16.4709 20.9997H18.9999V23.5287C18.9999 24.0794 19.4492 24.5287 19.9999 24.5287C20.5507 24.5287 20.9999 24.0794 20.9999 23.5287V20.9997H23.5289C24.0796 20.9997 24.5289 20.5504 24.5289 19.9997C24.5289 19.449 24.0796 18.9997 23.5289 18.9997Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2800_12609"
          x1="17.1057"
          y1="44.34"
          x2="24.0913"
          y2="1.45724"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00E700" />
          <stop offset="0.52" stopColor="#00FF00" stopOpacity="0.89" />
          <stop offset="0.62" stopColor="#19FF00" stopOpacity="0.91" />
          <stop offset="0.82" stopColor="#59FF00" stopOpacity="0.95" />
          <stop offset="1" stopColor="#99FF00" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2800_12609"
          x1="19.9924"
          y1="32.9477"
          x2="19.9924"
          y2="7.05098"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00776B" />
          <stop offset="1" stopColor="#00DF00" />
        </linearGradient>
        <radialGradient
          id="paint2_radial_2800_12609"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(20.0001 20.014) scale(5.21271)"
        >
          <stop stopColor="#E0FDFF" stopOpacity="0.8" />
          <stop offset="0.12" stopColor="#D9FCFF" stopOpacity="0.76" />
          <stop offset="0.33" stopColor="#C6FBFF" stopOpacity="0.66" />
          <stop offset="0.6" stopColor="#A7F9FF" stopOpacity="0.49" />
          <stop offset="0.92" stopColor="#7DF6FF" stopOpacity="0.26" />
          <stop offset="1" stopColor="#73F6FF" stopOpacity="0.2" />
        </radialGradient>
        <linearGradient
          id="paint3_linear_2800_12609"
          x1="23.693"
          y1="17.0212"
          x2="16.2205"
          y2="22.9331"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D1FD00" stopOpacity="0.8" />
          <stop offset="1" stopColor="#DEFD92" stopOpacity="0.5" />
        </linearGradient>
      </defs>
    </svg>
  )
}
